export default "__VITE_ASSET__rtxLLhlb__"